import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_FUNDING_FAQS } from './types';

import { requestFundingFaqsSuccess, requestFundingFaqsFailure } from './reducer';

const logger = new Logger('Saga:Faqs');

export function* requestFundingFaqsSaga() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.funding_search_list_faqs'),
    );

    const faqs = (response.data || []).map((faq, index) => ({
      ...faq,
      id: index,
    }));

    yield put(requestFundingFaqsSuccess(faqs));
  } catch (error) {
    logger.error('Failed to request funding faqs with the following error', error);
    yield put(requestFundingFaqsFailure(error));
  }
}

export default function* faqsSaga() {
  return yield all([takeLatest(REQUEST_FUNDING_FAQS, requestFundingFaqsSaga)]);
}
